<template>
    <div v-if="tourists.length">
        <v-form ref="form" v-model="valid">
            <div v-for="(tourist, touristIndex) in tourists" :key="tourist.personId">
                <v-row>
                    <v-col cols="12" :md="ownProduct ? 6 : 12">
                        <v-row class="align-end text-center">
                            <v-col cols="12" md="3" class="d-md-flex align-end">
                                <div class="me-2 text-no-wrap">
                                    <v-icon color="black" size="small">mdi-account-multiple</v-icon>
                                    <span class="font-weight-bold"> {{ touristIndex + 1 }}: </span>
                                </div>
                                <v-select
                                    v-model="tourists[touristIndex].prefix"
                                    :items="['Mr', 'Ms', 'Mrs']"
                                    :label="`${$t('salutation')}`"
                                    :rules="
                                        validationRules('salutation', [getRequiredRule(touristIndex, 'salutation')])
                                    "
                                    hide-details
                                />
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="tourists[touristIndex].firstName"
                                    :label="`${$t('first_name')}`"
                                    :rules="
                                        validationRules('firstName', [
                                            latinRule,
                                            getRequiredRule(touristIndex, 'firstName'),
                                        ])
                                    "
                                    hide-details
                                />
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field
                                    v-model="tourists[touristIndex].lastName"
                                    :label="`${$t('last_name')}`"
                                    :rules="
                                        validationRules('lastName', [
                                            latinRule,
                                            getRequiredRule(touristIndex, 'lastName'),
                                        ])
                                    "
                                    hide-details
                                />
                            </v-col>
                            <v-col v-if="ownProduct" cols="12" md="3">
                                <v-autocomplete
                                    v-model="tourists[touristIndex].citizenshipId"
                                    :label="$t('citizenship')"
                                    :items="countries"
                                    item-title="name"
                                    item-value="id"
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col v-if="ownProduct" cols="12" md="6">
                        <v-row class="align-end text-center">
                            <v-col cols="12" md="3">
                                <date-picker
                                    v-model="tourists[touristIndex].birthdate"
                                    :label="$t('birthdate')"
                                    :max="$dateFns.format(new Date())"
                                    hide-details
                                />
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    v-model="tourists[touristIndex].passport.number"
                                    :label="`${$t('document_number')}`"
                                    hide-details
                                />
                            </v-col>
                            <v-col cols="12" md="3">
                                <date-picker
                                    v-model="tourists[touristIndex].passport.expiryDate"
                                    :label="$t('expire_date')"
                                    :min="$dateFns.format(new Date())"
                                    hide-details
                                />
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
                <v-divider class="mt-8 mb-4" />
            </div>
        </v-form>
    </div>
</template>

<script lang="ts">
    import {Component, Emit, mixins, Prop} from 'vue-facing-decorator'
    import {FormValidationRulesMixin} from '@/mixins/FormValidationRulesMixin.vue'
    import DatePicker from '@/components/snippets/forms/DatePicker.vue'
    import {clone} from '@/utils/helpers'

    @Component({
        components: {DatePicker},
    })
    export class ModifyTravelers extends mixins(FormValidationRulesMixin) {
        @Prop({default: false, type: Boolean}) ownProduct

        @Prop({default: () => []}) _tourists
        @Prop({default: true}) _valid

        initialTourists = []

        @Emit()
        changeTourists(val) {
            return val
        }

        @Emit()
        changeValid(val) {
            return val
        }

        beforeMount() {
            this.initialTourists = clone(this.tourists)
        }

        getRequiredRule(touristIndex, prop) {
            return this.initialTourists[touristIndex][prop] ? this.requiredRule : () => true
        }

        get countries() {
            return runtimeStore.countries
        }

        get tourists() {
            return this._tourists
        }

        set tourists(val) {
            this.changeTourists(val)
        }

        get valid() {
            return this._valid
        }

        set valid(val) {
            this.changeValid(val)
        }
    }

    export default ModifyTravelers
</script>
